import type { ReactNode } from 'react'
import { Search } from 'lucide-react'

import { cn } from '@/lib/cn'

interface ToolbarProps {
  searchValue: string
  onSearchChange: (value: string) => void
  searchPlaceholder: string
  children?: ReactNode
}

/** Pasek filtrów nad tabelą — wyszukiwarka plus dodatkowe kontrolki. */
export function Toolbar({
  searchValue,
  onSearchChange,
  searchPlaceholder,
  children,
}: ToolbarProps) {
  return (
    <div className="card mb-6 flex flex-wrap items-center gap-3 p-4">
      <div className="relative min-w-[220px] flex-1">
        <Search
          size={18}
          className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-on-surface-variant"
          aria-hidden="true"
        />
        <input
          type="search"
          value={searchValue}
          onChange={(event) => onSearchChange(event.target.value)}
          placeholder={searchPlaceholder}
          aria-label={searchPlaceholder}
          className="w-full rounded-full border-2 border-transparent bg-surface-container-low py-2.5 pl-10 pr-4 text-sm transition-colors placeholder:text-on-surface-variant/60 focus:border-primary focus:bg-surface focus:outline-none"
        />
      </div>
      {children}
    </div>
  )
}

/** Przełącznik w formie pigułki, np. „Pokaż nieaktywne”. */
export function ToggleChip({
  checked,
  onChange,
  label,
}: {
  checked: boolean
  onChange: (checked: boolean) => void
  label: string
}) {
  return (
    <label
      className={cn(
        'inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-full px-4 py-2.5 text-sm font-semibold transition-colors',
        checked
          ? 'bg-primary/10 text-primary'
          : 'bg-surface-container-low text-on-surface-variant hover:bg-surface-container',
      )}
    >
      <input
        type="checkbox"
        checked={checked}
        onChange={(event) => onChange(event.target.checked)}
        className="h-4 w-4 rounded border-outline/40 text-primary focus:ring-primary"
      />
      {label}
    </label>
  )
}
